export default "__VITE_ASSET__HPZlA54P__"